import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const menuItems = [
  { name: 'لوحة التحكم',      path: '/dashboard',            icon: 'bi-house-door'    },
  { name: 'البث المباشر',     path: '/live',                 icon: 'bi-broadcast'     },
  { name: 'الفيديوهات',       path: '/videos',               icon: 'bi-camera-video'  },
  { name: 'الصوتيات',         path: '/audios',               icon: 'bi-mic-fill'      },
  { name: 'الأسئلة والأجوبة', path: '/qna',                  icon: 'bi-chat-dots'     },
  { name: 'المستخدمون',       path: '/users',                icon: 'bi-people-fill'   },
  { name: 'التصنيفات',        path: '/categories',           icon: 'bi-folder'        },
  { name: 'الوسوم',           path: '/collections/tags',     icon: 'bi-tags'          },
  { name: 'القراء',           path: '/readers',              icon: 'bi-person-circle' },
  { name: 'الوسائط',          path: '/collections/upload/files', icon: 'bi-images'   },
];

const Sidebar = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout, user, isSheikh } = useAuth();
  const visibleItems = isSheikh
    ? menuItems.filter(item => item.path === '/qna')
    : menuItems;
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const userMenuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (userMenuRef.current && !userMenuRef.current.contains(e.target)) {
        setUserMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = () => { logout(); navigate('/login'); };
  const handleNav = (path) => { navigate(path); onClose(); };

  const isActive = (path) =>
    path === '/dashboard'
      ? location.pathname === path
      : location.pathname.startsWith(path);

  return (
    <div className={`sidebar-container${isOpen ? ' sidebar-open' : ''}`}>
      {/* Mobile close button */}
      <button
        type="button"
        className="btn-close btn-close-white d-md-none"
        aria-label="إغلاق"
        onClick={onClose}
        style={{ position: 'absolute', top: 12, left: 12, fontSize: '0.7rem' }}
      />

      {/* Brand / Logo */}
      <div className="sidebar-brand">
        <img
          src="/logo-admin.png"
          alt="مسجد الموسوي - الادارة"
          style={{ width: 90, height: 90, objectFit: 'contain', borderRadius: 16 }}
        />
      </div>

      {/* Navigation */}
      <nav style={{ flex: 1, overflowY: 'auto' }}>
        <ul className="sidebar-nav">
          {visibleItems.map((item) => (
            <li key={item.path} className="sidebar-nav-item">
              <button
                className={`sidebar-nav-link${isActive(item.path) ? ' active' : ''}`}
                onClick={() => handleNav(item.path)}
              >
                <i className={item.icon}></i>
                <span>{item.name}</span>
              </button>
            </li>
          ))}
        </ul>
      </nav>

      {/* Footer */}
      <div className="sidebar-footer">
        <div ref={userMenuRef} style={{ position: 'relative' }}>
          <button
            type="button"
            className="sidebar-user-btn"
            onClick={() => setUserMenuOpen((v) => !v)}
          >
            <span className="sidebar-user-avatar">
              <i className="bi bi-person-fill"></i>
            </span>
            <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {user?.username || user?.email || 'المستخدم'}
            </span>
            <i
              className={`bi bi-chevron-${userMenuOpen ? 'up' : 'down'}`}
              style={{ fontSize: '0.65rem', color: 'rgba(255,255,255,0.5)', flexShrink: 0 }}
            />
          </button>

          {userMenuOpen && (
            <div className="sidebar-dropdown">
              <button
                type="button"
                className="sidebar-dropdown-btn"
                onClick={handleLogout}
              >
                <i className="bi bi-box-arrow-left"></i>
                تسجيل الخروج
              </button>
            </div>
          )}
        </div>

        {/* Golden logo mark – bottom right */}
        <div className="sidebar-logo-mark">
          <img
            src="/logo-admin.png"
            alt="logo"
            style={{ width: 38, height: 38, objectFit: 'contain', borderRadius: 8, opacity: 0.7 }}
          />
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
